import { graphql } from '../../gql';

export const DATE_SELECTION_LIST_QUERY = graphql(`
  query DateSelectionList {
    selectionList {
      week {
        id
        shortName
      }
      month {
        id
        shortName
      }
    }
  }
`);
